import { IFileData, IFileDataCrud } from 'clickNgo/models/file'

export const mapLegalFileFromCrud = (data: IFileDataCrud[]): IFileData[] =>
  data.map((source) => ({
    fileName: source.Attachment,
    uid: source.UID,
    created: source.Created,
    createdBy: source.CreatedBy,
    entryId: source.EntryId,
    modified: source.Modified,
    modifiedBy: source.ModifiedBy,
    partnerId: source.PartnerId,
    type: source.Type,
  }))
